export default "__VITE_ASSET__C6P3X5t5__"